import { requestApi } from '../util/network'

// 获取文章列表
export const getActivityList =
    (params) =>
      requestApi(
        '/Activity/index',
        'GET',
        params
      )

// 获取文章详情
export const getActivityDetail =
    (params) =>
      requestApi(
        '/Activity/detail',
        'GET',
        params
      )
